import { HttpProvider, type InferenceProvider } from '@bill/core';
import { DemoProvider } from './demo.js';

/**
 * Which brain the app talks to.
 *
 * `?demo` in the URL (or VITE_DEMO=1 at build time) swaps in the offline
 * provider so the flow can be tried with no key and no quota. The choice is
 * sticky for the tab so it survives navigation within the app.
 */
const DEMO_FLAG = 'bill-splitter:demo';

export function isDemo(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('demo')) {
      sessionStorage.setItem(DEMO_FLAG, params.get('demo') === '0' ? '0' : '1');
    }
    if (sessionStorage.getItem(DEMO_FLAG) === '1') return true;
  } catch {
    // storage unavailable; fall through to the build-time flag
  }
  return import.meta.env.VITE_DEMO === '1';
}

let instance: InferenceProvider | null = null;

export function getProvider(): InferenceProvider {
  if (instance) return instance;
  instance = isDemo()
    ? new DemoProvider()
    : new HttpProvider(
        import.meta.env.VITE_APP_TOKEN
          ? { token: import.meta.env.VITE_APP_TOKEN as string }
          : {},
      );
  return instance;
}
